import { Container, CssBaseline, Link, Typography, makeStyles } from "@mui/material";
import React from "react";


function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary">
      {"Copyright © "}
      <Link color="inherit" href="https://gearsofjoy.com/">
        Gears of Joy LLC
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

// const useStyles = makeStyles((theme) => ({
//   root: {
//     display: "flex",
//     flexDirection: "column",
//     minHeight: "100vh"
//   },
//   main: {
//     marginTop: theme.spacing(8),
//     marginBottom: theme.spacing(2)
//   },
//   footer: {
//     padding: theme.spacing(3, 2),
//     marginTop: "auto",
//     backgroundColor:
//       theme.palette.type === "light"
//         ? theme.palette.grey[200]
//         : theme.palette.grey[800]
//   }
// }));

export default function Footer(props) {
  // const classes = useStyles();

  return (
    // <div className={classes.root}>
      /* <CssBaseline />
      <Container component="main" className={classes.main} maxWidth="sm">
        <Typography variant="h2" component="h1" gutterBottom>
          Sticky footer
        </Typography>
        <Typography variant="h5" component="h2" gutterBottom>
          {"Pin a footer to the bottom of the viewport."}
          {"The footer will move as the main element of the page grows."}{" "}
          {"Pin a footer to the bottom of the viewport."}
          {"The footer will move as the main element of the page grows."}{" "}
          {"Pin a footer to the bottom of the viewport."}
          {"The footer will move as the main element of the page grows."}{" "}
          {"The footer will move as the main element of the page grows."}{" "}
          {"Pin a footer to the bottom of the viewport."}
          {"The footer will move as the main element of the page grows."}
        </Typography>
        <Typography variant="body1">Sticky footer placeholder.</Typography>
      </Container> */
      <footer >
        <Container sx={{ pt: 2, pb: 2, alignContent: 'center', justifyContent: 'center', display: 'flex'}}>
          {/* <Typography variant="body1">
            My sticky footer can be found here.
          </Typography> */}
          <Copyright />
        </Container>
      </footer>
    // </div>
  );
}
